import React from "react";
import { compose } from "recompose";
import { defineMessages, useIntl } from "react-intl";
import EnhanceCartItemQuantityForm from "../CartItemQuantityForm/EnhanceCartItemQuantityForm";
import EnhanceRemoveItemCart from "../CartItemRemoveForm/EnhanceRemoveItemCart";
import UpdateCartItemQtyMutation from "theme/modules/Cart/CartItem/CartItemQuantityForm/UpdateCartItemQtyMutation.gql";
import RemoveCartItemMutation from "theme/modules/Cart/CartItem/CartItemRemoveForm/RemoveCartItemMutation.gql";
import Image from "theme/components/atoms/Image";
import Price from "theme/components/atoms/Typography/Price";
import IconButton from "theme/components/atoms/Button/IconButton";
import CartItemStatus from "../CartItemStatus";
import CartItemQuantityForm from "../CartItemQuantityForm";
import TrackingLink from "theme/components/atoms/Typography/Link/TrackingLink";

const messages = defineMessages({
  removeItem: {
    id: "modules.Cart.MiniCart.MiniCartContent.MiniCartItem.removeItem",
    defaultMessage: "Remove",
  },
  optionLabel: {
    id: "modules.Cart.MiniCart.MiniCartContent.MiniCartItem.optionLabel",
    defaultMessage: "{optionName}: {optionValue}",
  },
});

const MiniCartItem = ({
  item,
  onRefreshQuantity,
  refreshQuantityStatus,
  removeItemStatus,
  removeItem,
}) => {
  const intl = useIntl();
  return (
    <div className="mini-cart-item">
      <div className="mini-cart-item__image">
        {item.product?.imageUrl ? (
          <Image
            src={item.product.imageUrl}
            alt={item.name}
            format="small"
            appearance="full"
          />
        ) : null}
      </div>
      <div className="mini-cart-item__content">
        <div className="mini-cart-item__name">
          {item.product ? (
            <TrackingLink
              to={item.product.path}
              eventName="Product Clicked"
              eventPayload={{
                sku: item.sku,
                name: item.name,
              }}
            >
              {item.name}
            </TrackingLink>
          ) : (
            item.name
          )}
        </div>
        <CartItemStatus
          refreshQuantityStatus={refreshQuantityStatus}
          removeItemStatus={removeItemStatus}
        />
        <div className="mini-cart-item__details">
          <div className="mini-cart-item__price">
            <Price price={item.priceInfo.rowTotalInclTax} />
          </div>
          <div className="mini-cart-item__quantity">
            <CartItemQuantityForm
              quantity={item.qty}
              item_id={item.item_id}
              disabled={removeItemStatus.commandPending}
              onRefreshQuantity={onRefreshQuantity}
              refreshQuantityPending={refreshQuantityStatus.commandPending}
              appearance={"small"}
            />
          </div>
        </div>
      </div>
      <div className="mini-cart-item__remove">
        <IconButton
          onClick={removeItem}
          icon="cross"
          iconSize="small"
          title={intl.formatMessage(messages.removeItem)}
          state={
            removeItemStatus.commandPending
              ? "pending"
              : refreshQuantityStatus.commandPending
              ? "disabled"
              : undefined
          }
          onDisableClick={() => {}}
        />
      </div>
    </div>
  );
};

export default compose(
  EnhanceRemoveItemCart({ RemoveCartItemMutation }),
  EnhanceCartItemQuantityForm({ UpdateCartItemQtyMutation })
)(MiniCartItem);
